import styles from './FavoriteNumberField.module.scss';

import { FC, useCallback, useState } from 'react';

import { Typography } from '@shared/Typography';
import { Button } from '@shared/Button';
import { LotteryGameRoomBodyButton } from '@features/LotteryGame';
import { setFavoriteNumbers, useAppDispatch, useAppSelector } from '@app/store';
import { useTranslation } from 'react-i18next';

const numbers = Array.from({ length: 50 }, (_, i) => i + 1);

interface FavoriteNumberFieldProps {
  setShowNumberField: (show: boolean) => void;
}

export const FavoriteNumberField: FC<FavoriteNumberFieldProps> = ({
  setShowNumberField,
}) => {
  const dispatch = useAppDispatch();
  const { favoriteNumbers } = useAppSelector((s) => s.persistValues);
  const [selectedNumbers, setSelectedNumbers] = useState<number[]>(favoriteNumbers);

  const { t } = useTranslation('mainPage');

  const stage = selectedNumbers.length >= 10 ? 'anotherTurn' : 'myTurn';

  const handleClickNumber = useCallback((num: number) => {
    setSelectedNumbers((prev) => {
      if (prev.includes(num)) return prev.filter((n) => n !== num);
      else return [...prev, num];
    });
  }, []);

  return (
    <div className={styles.fnfContainer}>
      <Typography component="h1">{t('autoPlayCreation.selectNumbers')}</Typography>
      <Typography component="h3" variant="secondary">
        {t('autoPlayCreation.ChooseNumbers')}
      </Typography>
      <div className={styles.numberField}>
        {numbers.map((num) => (
          <LotteryGameRoomBodyButton
            num={num}
            key={num}
            stage={stage}
            onClick={handleClickNumber}
            anotherNumber={false}
            myNumber={selectedNumbers.includes(num)}
          />
        ))}
      </div>
      <Button
        title={t('autoPlayCreation.select')}
        variant="filled"
        onClick={() => {
          dispatch(setFavoriteNumbers(selectedNumbers));
          setShowNumberField(false);
        }}
        className={styles.fnfSelectButton}
      />
    </div>
  );
};
